import { render } from "./ReSettingAuthAppComponent.vue?vue&type=template&id=1f0f4dbb&scoped=true"
import script from "./ReSettingAuthAppComponent.vue?vue&type=script&lang=js"
export * from "./ReSettingAuthAppComponent.vue?vue&type=script&lang=js"

import "./ReSettingAuthAppComponent.vue?vue&type=style&index=0&id=1f0f4dbb&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0f4dbb"]])

export default __exports__